<template>

    <v-container>
    <v-card class="mx-auto" max-width="550">
    <v-system-bar  color="pink darken-2"></v-system-bar>
  

      <v-app-bar color="#424242" dark dense @click.stop="$router.push('/')">
        <v-icon>home</v-icon>
        <v-spacer></v-spacer>
        <v-toolbar-title>Microcise</v-toolbar-title>
      </v-app-bar>




     <div>
     
      <v-card-title class="text-h5  text-center grey lighten-2">Forgotten Password</v-card-title>
      <div>
      <div v-if="formState === 'forgottenAsk'">
          <v-row>
              <v-col cols="12" >
                  Trouble logging in? Please provide your email address and we will send you a reset code
              </v-col>
          </v-row>      
          <v-row>
              <v-col cols="12" >
                  <v-text-field
                      v-model="form.username"
                      color="pink darken-2"
                      :rules="[rules.required]"
                      label="email"
                      hint="">
                  </v-text-field>
              </v-col>
          </v-row>
          <div class='formcontainer'>
              <button v-on:click='forgottenAsk' class='button'>Reset Password</button>
          </div>
      </div>

   </div>


    <div v-if="formState === 'forgottenConfirm'">
        <v-card  >
            <v-container fluid>
          <v-row>
              <v-col cols="12" >
                  Please check your email for a reset code
              </v-col>
          </v-row>             
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="form.confirmationCode"
                            color="pink darken-2"
                            :rules="[rules.required]"
                            label="Reset code"
                            required>
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" >
                        <v-text-field
                            v-model="form.password1"
                            color="pink darken-2"
                            :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.min]"
                            :type="showPassword1 ? 'text' : 'password'"
                            label="Password"
                            name="password1"
                            hint="At least 8 characters"
                            counter
                            @click:append="showPassword1 = !showPassword1">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" >
                        <v-text-field
                            v-model="form.password2"
                            color="pink darken-2"
                            :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, passwordConfirmationRule]"
                            :type="showPassword2 ? 'text' : 'password'"
                            label="Password confirmation"
                            name="password2"
                            hint="At least 8 characters"
                            counter
                            @click:append="showPassword2 = !showPassword2">
                        </v-text-field>
                    </v-col>
                </v-row>
                <div class='formcontainer'>
                    <button v-on:click='forgottenConfirm' class='button'>Change Password</button>
                </div>
                
            </v-container>
        </v-card>
    </div>


</div>

</v-card>

  </v-container>

</template>

<script >
import {Auth} from 'aws-amplify'

export default {
    name: 'home',
    props: ['toggle'],
    data() {
        return {
            formState: 'forgottenAsk',
            showPassword1: false,
            showPassword2: false,            
            form: {
                username: '',
                confirmationCode: '',
                password1: '',
                password2: ''
          },
        rules: {
            required: value => !!value || 'Required.',
            min: v => v.length >= 8 || 'Min 8 characters',
            email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
            }, 
        }             
      }
    },
   computed: {
       passwordConfirmationRule() {
         return () => (this.form.password1 === this.form.password2) || 'Passwords must match'
       }
   },    
    methods: {

        async forgottenAsk() {
            const { username} = this.form
            console.log("ForgottenPassword:: forgottenAsk")
            console.log(username)
            await Auth.forgotPassword(username)
            this.formState = 'forgottenConfirm'
        },

        async forgottenConfirm() {
      
            await Auth.forgotPasswordSubmit(this.form.username, this.form.confirmationCode, this.form.password1)
            alert('Successfully reset password! Sign in to view the app.')
            this.$router.push('auth');
            
        }        
    }
} 

</script>


<style>

.formcontainer {
     display: flex;
     flex-direction: column;
     width: 500px;
     margin: 0 auto;
}
.input {
     margin-bottom: 7px;
     height: 38px;
     border: none;
     outline: none;
     border-bottom: 2px solid #ddd;
     font-size: 20px;
}
.button {
     height: 45px;
     border: none;
     outline: none;
     background-color: #dddddd;
     margin-top: 8px;
     cursor: pointer;
     font-size: 18px;
}
.button:hover {
     opacity: .7
}
</style>